import * as moment from "moment";
import { Moment } from "moment";

export enum ProductServiceType {
    PRODUCTS = 'PRODUCTS',
    SERVICES = 'SERVICES'
}

export interface ProductService {
    _id?: string;
    label: string;
    type: ProductServiceType;
    classNumber: number;
    trademark?: {
        ref: string;
        name?: string;
        identifierNumber: string;
        countryOfDesignation: string;
    }
    organizationId?: string;
    lang?: string;
    translations: {
        [label: string]: string;
    }
}